import React, { useState } from "react";

const Agreement = ({ FormData, Para, id }) => {
    const [agreed, setAgreed] = useState(false);

    const getInitials = (first, last) =>
        `${first?.[0] || ""}${last?.[0] || ""}`.toUpperCase();

    return (
        <div className="flex items-start gap-2">
            <input
                type="checkbox"
                checked={agreed}
                onChange={(e) => {
                    setAgreed(e.target.checked);
                    FormData[id] = e.target.checked;
                }}
                className="mt-1"
            />

            <span className="flex-1">
                <span className="underline min-w-[40px] text-center font-bold">
                    {agreed
                        ? getInitials(
                            FormData.first_name,
                            FormData.last_name
                        )
                        : ""}
                </span> {Para}
            </span>
        </div>
    );
};

export default Agreement;